module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flexed-column-wrapper-fixed-nav",
    staticStyle: {
      "width": "100%",
      "height": "calc(100% - 50px)"
    },
    style: ({
      minWidth: (_vm.minPageWidthInPixels + "px")
    })
  }, [_c('div', {
    staticClass: "fixed-navbar",
    staticStyle: {
      "width": "100%"
    },
    style: ({
      height: (_vm.heightOfNavInPixels + "px")
    })
  }, [_vm._t("nav-slot")], 2), _vm._v(" "), _c('div', {
    staticClass: "rest-of-height",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._t("body-slot")], 2), _vm._v(" "), _vm._t("dialogs")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-93b080b2!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/layouts/fixedNavBar/fixedNavBar.vue
// module id = 1657
// module chunks = 61